import CategorySelection from "../component/CategorySelection";
import SearchBar from "../component/SearchBar";
import Filter from "../component/Filter";
import PracticePageFilter from "../variables/PracticePageFilter";
import QuestionRow from "../component/QuestionRow";
import { useParams } from "react-router-dom";
import useListApi from "../../../../hooks/useListApi";
import URLS from "../../../../API/Axios/URLS";
import Paginator from "../../../../components/Table/Paginator";

import { IoIosSad } from "react-icons/io";
import React from "react";

export function getRoute(name, num) {
    name = name.toLowerCase().split(" ").join("-")
    // if the last character is  - then remove it
    if (name[name.length - 1] === "-") {
        name = name.slice(0, name.length - 1)
    }
    return `/practice/${name}/${num}`
}

export default function PracticeRoot({ className, ...props }) {
    const { cat } = useParams()
    let myCat = cat ? cat : "Wap"
    let [questionsData, filter, isDataLoading, actions] = useListApi(URLS.listQuestions + myCat, {
        sorting: "default",
        difficulty: "default",
        practiced: "default",
        notes: "default",
        page_size: 15,
        mark: "all",
        category: myCat,
        search: ""

    }, () => {
        let focus_auto_section = document.getElementById("focus-auto-section")
        if (focus_auto_section) {
            focus_auto_section.scrollIntoView({ behavior: "smooth" })
        }

    });




    return (
        <div id={"focus-auto-section"} className={`flex pt-10  h-full flex-col gap-4 lg:gap-8 ${className}`}>
            {/*<HeroSection/>*/}
            <div className={"   mt-5 lg:mt-0 justify-center items-center flex flex-row gap-8 px-10"}>
                <CategorySelection />
            </div>


            <div className={"flex flex-col justify-center items-center gap-2 "}>
                <div className={"line w-full "} />
                <div
                    className={"flex w-full  justify-center items-center flex-col px-4  lg:px-0 lg:flex-row gap-2"}>
                    <SearchBar placeholder={"# Question No... or Title... or Tag..."}
                        value={filter?.search}
                        onChange={(e) => actions?.updateFilter({
                            search: e.target.value
                        })}
                        className={"lg:w-[372px]  w-full mx-8 my-auto  "} />
                    <div
                        className={"flex-wrap mt-5 lg:mt-0 justify-center items-center flex flex-row gap-8 px-10"}>
                        {
                            Object.keys(PracticePageFilter).map((key, index) => (
                                <React.Fragment key={index}>
                                    <Filter
                                        currentValue={filter[key]}


                                        select={actions.updateFilter}
                                        {...PracticePageFilter[key]}


                                    />
                                    {index + 1 < Object.keys(PracticePageFilter).length &&
                                        <div className={"w-[1px] hidden lg:flex bg-gray-200 h-14"} />}
                                </React.Fragment>
                            ))
                        }
                    </div>
                </div>
                <div className={"line w-full"} />
            </div>

            <div
                className={"w-full mb-8 lg:w-[80%] xl:w-2/3  self-center flex overflow-auto  flex-col justify-center items-center px-8"}>
                {
                    questionsData?.totalPages ? <p className={"font-bold text-xl"}>
                        Total {questionsData?.count} results found
                    </p> : <></>
                }
                <div className={"mt-8 w-full flex flex-col  gap-4 lg:gap-6"}>
                    {isDataLoading && <div className={"flex flex-col gap-2 lg:gap-2"}>
                        {
                            Array(13).fill(0).map((_, index) => (
                                <QuestionRow.Loading key={index} className={"w-full"} />
                            ))
                        }
                    </div>
                    }
                    {
                        !isDataLoading && questionsData?.results?.map((question, index) => (
                            <QuestionRow num={question.num}
                                key={index}
                                metaData={question.metaData}
                                tested={question.tested}
                                id={question.id}

                                difficulty={question.difficulty}
                                title={question?.route_name || question.name}
                                to={getRoute(question?.route_name || question.name, question.id)} />
                        ))
                    }
                </div>
                {
                    questionsData?.totalPages ? <Paginator
                        hasGoToBox
                        className={"mt-10"}
                        currentPage={questionsData?.currentPage}
                        totalPages={questionsData?.totalPages}
                        onNext={(e) => {
                            actions.loadNextPage()
                        }}
                        onPrev={(e) => actions.loadPrevPage()}
                        onPageNumberClick={(e) => {
                            actions.loadSpecificPage(e)
                        }}
                    /> : <></>
                }
                {
                    !isDataLoading && questionsData?.results?.length === 0 &&
                    <div className={"flex flex-col my-12 gap-2 items-center"}>
                        <IoIosSad className={"text-4xl"} />


                        <p className={"font-bold text-xl"}>
                            Total {questionsData?.count} results found
                        </p>
                    </div>
                }

            </div>


        </div>

    )
}
